import React from 'react';
import classnames from 'classnames';

const PseudoCitySubStation = ({station, validations, select}) => {
  let {closed, message: closed_message} = validations || {};
  return (
    <div
      onClick={select(station, closed)}
      className={
        classnames({closed: closed})
      }>
      <div className="content">
        <p className="subtitle">
          {station.subtitle}
        </p>
        <p className="title">
          {station.title}
        </p>
        <p className={
          classnames("small error", {hidden: !closed})
        }>
          {closed_message}
        </p>
      </div>
      <div className="aside">
        <p className="code">{station.code}</p>
      </div>
    </div>
  );
}

export default PseudoCitySubStation;
